import React from 'react';
import {useDispatch} from 'react-redux';
import './AutomaticDelete.scss';
import * as moduleActions
  from '../../../redux/modules/existingAutomatics/existingAutomatics.module';
import {
  AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL,
  AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS,
  openModal as openModalAction,
} from '../../../redux/modules/modals/modals.module';

const AutomaticDelete = ({ onClose, fund, type }) => {
  const dispatch = useDispatch();
  let payload = {};
  const selectedTransferDaysArray = fund?.transferDays;
  const selectedTransferMonthsArray = fund?.transfers;
  if (type === 'REDEEM') {
    if (fund.deliveryType?.enumerationName === 'CheckToAddress') {
      payload = {
        systematicTransactions: [
          {
            amount: fund.amount,
            agreementId: fund.sourceAgreementKey.agreementID,

            systematicActivitySchedule: {
              investedEveryMonth: fund.investedEveryMonth,
              transferDays: selectedTransferDaysArray,
              transfers: selectedTransferMonthsArray,
              deferMonths: [],
            },
            deliveryType: fund.deliveryType,
            fiduciaryRedemptionType: fund.fiduciaryRedemptionType,
            redemptionType: fund.redemptionType,
            irawithholding: fund.IRAWithholding,
            systematicTransactionStatus: 'DELETE',
            systematicTransactionType: type,
            electionAgreementUniqueId1: fund.electionAgreementUniqueId1,
            electionAgreementUniqueId2: fund.electionAgreementUniqueId2,
          },
        ],
        skipStatus: 'NONE',
      };
    } else {
      payload = {
        bankDto: {
          bankAgreementID: fund.bankAgreementKey.bankAgreementID,
          sameDayBank: fund.bankAgreementKey.sameDayBank,
        },
        systematicTransactions: [
          {
            amount: fund.amount,
            agreementId: fund.sourceAgreementKey.agreementID,
            systematicActivitySchedule: {
              investedEveryMonth: fund.investedEveryMonth,
              transferDays: selectedTransferDaysArray,
              transfers: selectedTransferMonthsArray,
              deferMonths: [],
            },
            deliveryType: fund.deliveryType,
            fiduciaryRedemptionType: fund.fiduciaryRedemptionType,
            redemptionType: fund.redemptionType,
            irawithholding: fund.IRAWithholding,
            systematicTransactionStatus: 'DELETE',
            systematicTransactionType: type,
            electionAgreementUniqueId1: fund.electionAgreementUniqueId1,
            electionAgreementUniqueId2: fund.electionAgreementUniqueId2,
          },
        ],
        skipStatus: 'NONE',
      };
    }
   } else {
    payload = {
      systematicTransactions: [
        {
          amount: fund.amount,
          agreementId: fund.targetAgreementKey.agreementID,
          sourceAgreementId: fund.sourceAgreementKey.agreementID,
          systematicActivitySchedule: {
            investedEveryMonth: fund.investedEveryMonth,
            transferDays: selectedTransferDaysArray,
            transferMonths: selectedTransferMonthsArray,
            deferMonths: [],
          },
          systematicTransactionStatus: 'DELETE',
          systematicTransactionType: type,
          electionAgreementUniqueId1: fund.electionAgreementUniqueId1,
          electionAgreementUniqueId2: fund.electionAgreementUniqueId2,
        },
      ],
      skipInfo: 'NONE',
    };
  }
  return (
    <div className="automatic-delete-container">
      <div className="automatic-delete-info-container">
        <div className="automatic-delete-title">
          Are you sure you want to delete this transaction ?
        </div>
        <div className="automatic-delete-sub-title">
          Deleting an automatic transaction may take{' '}
          <span className="automatic-delete-emphasis">
            up to three business days to process
          </span>
          . If your next transaction is scheduled in this time period, it may
          still process.
        </div>
      </div>
      <div className="automatic-delete-buttons-container">
        <a
          className="automatic-delete-cancel-btn"
          id="cancel-delete-btn"
          onClick={onClose}
        >
          No, Cancel
        </a>
        <button
          className="automatic-delete-delete-btn"
          buttontype="primary"
          id="delete-btn"
          stylename="automatic-delete-delete-btn"
          onClick={(e) => {
            Promise.all([
              dispatch(moduleActions.deleteAutoSell(payload)),
              onClose(),
            ])
              .then(() => {
                Promise.all([
                  dispatch(moduleActions.getExistingAutoSell()),
                  dispatch(moduleActions.getExistingAutoExchange()),
                ])
                  .then(() => {
                    dispatch(
                      openModalAction(
                        AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS,
                        {
                          isDelete: true,
                          type,
                        }
                      )
                    );
                  })
                  .catch(() => {
                    dispatch(
                      openModalAction(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL, {
                        isDelete: true,
                      })
                    );
                  });
              })
              .catch((err) => {
                dispatch(
                  openModalAction(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL, {
                    isDelete: true,
                  })
                );
              });
          }}
        >
          Yes, Delete
        </button>
      </div>
    </div>
  );
};

export default AutomaticDelete;
